import styled from 'styled-components';

export const Container = styled.div`
    max-width: 150px;
    max-height: 80px;
`;

export const ImageHolder = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;